import { UrlUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { getProductCompatibilitySummary } from '../AppListing.utils';
import MultipleProductCompatibilitySummary from './MultipleProductCompatibilitySummary';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ProductCompatibilitySummary = props => {
  const {
    cloudCompatibleProducts,
    serverCompatibleProducts,
    dataCenterCompatibleProducts,
    totalVersionCount,
    versionHistoryUrl
  } = props;
  const allCompatibilities = [...cloudCompatibleProducts, ...serverCompatibleProducts, ...dataCenterCompatibleProducts];
  const compatibleWithMultipleProducts = new Set(allCompatibilities.map(product => product.id)).size > 1;
  if (compatibleWithMultipleProducts) {
    return /*#__PURE__*/_jsx(MultipleProductCompatibilitySummary, {
      compatibleProducts: allCompatibilities,
      totalVersionCount: totalVersionCount,
      versionHistoryUrl: versionHistoryUrl
    });
  }
  const summary = getProductCompatibilitySummary(allCompatibilities);
  const showMoreVersionsLink = totalVersionCount > 1;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: ["for ", summary, showMoreVersionsLink && /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsx("a", {
        href: UrlUtils.removeQueryParamsFromUrl(versionHistoryUrl),
        title: "View version history for more details",
        children: "and more"
      })]
    })]
  });
};
export default ProductCompatibilitySummary;